<template>
	<ul class="breadcrumb flex pb-4 ais-Breadcrumb-list" v-if="isBreadCrumbValid" itemscope itemtype="https://schema.org/BreadcrumbList">
		<button class="link">
			<a @click="$router.go(-1)" href.prevent="#">
				<span class="flex gap-2"><img src="/custom/loja/assets/media/icons/arrow-left-big.svg" />Voltar</span>
			</a>
		</button>
		<div class="mx-2">|</div>
		<li v-for="(b, i) in productBreadcrumb" :key="i" class="flex" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
			<span class="flex items-center flex-wrap mx-2 head-bold" v-if="i > 0">/</span>
			<NuxtLink :to="b.link" class="ais-Breadcrumb-link" itemscope itemtype="https://schema.org/WebPage" itemprop="item" :itemid="b.link">
				<span itemprop="name">{{ b.name }}</span>
			</NuxtLink>
			<meta itemprop="position" :content="i + 1" />
		</li>
	</ul>
</template>

<script>
export default {
	props: {
		departamento: {
			type: Array,
			default: [],
		},
		grupo: {
			type: Array,
			default: [],
		},
		secao: {
			type: Array,
			default: [],
		},
	},
	computed: {
		isBreadCrumbValid() {
			if (this.departamento.length > 0 && this.grupo.length > 0 && this.secao.length > 0) {
				return true
			}
			return false
		},
		productBreadcrumb() {
			let catLvl0 = String(this.departamento[0]).toLowerCase().replace(" ", "-").replace(",", "").normalize("NFD")
			let catLvl1 = String(this.secao[0]).toLowerCase().replace(" ", "-").replace(",", "").normalize("NFD")
			let catLvl2 = String(this.grupo[0]).toLowerCase().replace(" ", "-").replace(",", "").normalize("NFD")

			catLvl0 = this.$helpers.criarUrlAmigavel(catLvl0)
			catLvl1 = this.$helpers.criarUrlAmigavel(catLvl1)
			catLvl2 = this.$helpers.criarUrlAmigavel(catLvl2)

			let lvl0 = {
				name: String(this.departamento[0]),
				link: "/lista/" + catLvl0,
			}

			let lvl1 = {
				name: String(this.secao[0]),
				link: "/lista/" + catLvl0 + "/" + catLvl1,
			}

			let lvl2 = {
				name: String(this.grupo[0]),
				link: "/lista/" + catLvl0 + "/" + catLvl1 + "/" + catLvl2,
			}

			let breadcrumbs = [lvl0, lvl1, lvl2]

			return breadcrumbs
		},
	},
}
</script>

<style scoped lang="scss">
.breadcrumb {
	li {
		font-size: 16px;
		font-weight: 300;
		line-height: 19px;
		color: #3c484d;
		a {
			font-size: 16px;
			font-weight: 300;
			line-height: 19px;
			color: #3c484d;
		}
	}
}
</style>
